/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: de9cdd23047a
 */

import * as z from "zod";
import {
  AssetDeliveryType,
  AssetDeliveryType$zodSchema,
} from "./assetdeliverytype.js";
import {
  FetchDeliveryType,
  FetchDeliveryType$zodSchema,
} from "./fetchdeliverytype.js";
import {
  ManagedDeliveryType,
  ManagedDeliveryType$zodSchema,
} from "./manageddeliverytype.js";
import {
  SocialDeliveryType,
  SocialDeliveryType$zodSchema,
} from "./socialdeliverytype.js";

/**
 * Delivery types accepted by the explicit operation.
 */
export type ExplicitDeliveryType =
  | ManagedDeliveryType
  | AssetDeliveryType
  | FetchDeliveryType
  | SocialDeliveryType;

export const ExplicitDeliveryType$zodSchema: z.ZodType<ExplicitDeliveryType> = z
  .union([
    ManagedDeliveryType$zodSchema,
    AssetDeliveryType$zodSchema,
    FetchDeliveryType$zodSchema,
    SocialDeliveryType$zodSchema,
  ]).describe("Delivery types accepted by the explicit operation.");
